<template>
  <div id="home">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Your Account</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">Balance</v-card-title>
                  <v-card-subtitle class="text-start">Your current balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7" >${{ (balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Transaction History</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Date</th>
                <th class="text-left">Details</th>
                <th class="text-left">Credit $</th>
                <th class="text-left">Debit $</th>
                <th class="text-left">Balance $</th>
                <th class="text-left">Credit K</th>
                <th class="text-left">Debit K</th>
                <th class="text-left">Balance K</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in transactions" :key="transaction.id">
                <td>
                  <h4>{{ transaction.date | moment('timezone', timezone, " h:mm:ss a") }}</h4>
                  {{ transaction.date | moment('timezone', timezone, " Do MMMM YYYY") }}
                </td>
                <td>
                  <h4>{{ transaction.category }}</h4>
                  <div>{{ transaction.description }}</div>
                  <div>{{ transaction.reference }}</div>
                </td>
                <td v-if="transaction.type === 'CREDIT'"><span v-if="transaction.amount !== 0">+${{ (transaction.amount/100).toFixed(2) }}</span></td>
                <td v-if="transaction.type === 'DEBIT'"></td>
                <td v-if="transaction.type === 'DEBIT'"><span v-if="transaction.amount !== 0">-+${{ (transaction.amount/100).toFixed(2) }}</span></td>
                <td v-if="transaction.type === 'CREDIT'"></td>
                <td><span v-if="transaction.amount !== 0">${{ (transaction.balance/100).toFixed(2) }}</span></td>
                <td v-if="transaction.type === 'CREDIT'"><span v-if="transaction.kels !== 0">+{{ transaction.kels }} k</span></td>
                <td v-if="transaction.type === 'DEBIT'"></td>
                <td v-if="transaction.type === 'DEBIT'"><span v-if="transaction.kels !== 0">-${{ transaction.kels }} k</span></td>
                <td v-if="transaction.type === 'CREDIT'"></td>
                <td><span v-if="transaction.kels !== 0">{{ transaction.kels_balance }} k</span></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      balance: 0,
      transactions: null
    };
  },
  mounted() {
    this.getBalance();
    this.getTransactions();
    this.getTimezone();
  },
  computed: {},
  methods: {
    getBalance() {
      this.$store.dispatch("retrieveBalance").then(() => {
        this.balance = this.$store.getters.balance;
      });
    },
    getTransactions() {
      if (this.transactions === null) {
        this.$store.dispatch("retrieveTransactions").then(() => {
          this.transactions = this.$store.getters.transactions;
        });
      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>